import { getASTenantId, getRefreshToken, getToken } from "../../../shared/local-storage-handler/local-storage-handler";
import serverFunctions from "./serverFunctions";

export const closeIFrameDialog = (msg) => {
  window.parent.postMessage(`${msg}`, '*');
};

export const openAddNewConnectionDialog = async (connectionUId) => {
  const params = {
    connectionUId: connectionUId,
    token: getToken(),
    refreshToken: getRefreshToken(),
    asTenantUid: getASTenantId()
  }
  const url = `data-collections/add-new-data-collection?connectionUId=${params?.connectionUId}
                                &AccessToken=${params?.token}&RefreshToken=${params?.refreshToken}
                                &ASTenantUId=${params?.asTenantUid}
                                &closeWindowOnPopupClose=true`

  await serverFunctions.openDialog(url).then().catch(alert);
}